import React, {useEffect, useMemo, useRef, useState} from 'react';
import {
    IconArrowLeftSvg,
    IconArrowRightSvg,
} from "../common/svg";
import {
    shuffle,
} from "../../helpers/data-helpers";

import "../../styles/shop/prints-landing-carousel.scss";

// FIX: I’m shuffling on every render
const PrintsLandingCarousel = ({
    slides,
    shuffleSlides = false,
}) => {
    const [slidePosition, setSlidePosition] = useState(0);

    const carouselRef = useRef(null);
    const clipperRef = useRef(null);

    const displaySlides = useMemo(() => {
        return shuffleSlides ? shuffle([...slides]) : slides;
    }, [slides, shuffleSlides]);

    const slideWidth = () => {
        const carousel = carouselRef.current;
        if (!carousel) return 0;

        const cells = carousel.querySelectorAll('div.carousel-cell');
        if (cells.length === 0) return 0;

        const gap = parseInt(window.getComputedStyle(carousel).columnGap) || 0;
        return cells[0].offsetWidth + gap;
    }

    const positionCarousel = () => {
        const carousel = carouselRef.current;
        if (!carousel) return;

        const width = slideWidth();
        if (width === 0) return;

        carousel.style.transform = `translateX(-${slidePosition * width}px)`;
    };

    const stepCarousel = (step) => {
        const carousel = carouselRef.current;
        const clipper = clipperRef.current;
        if (!carousel || !clipper) return;

        const cells = carousel.querySelectorAll('div.carousel-cell');
        if (cells.length === 0) return;

        const width = slideWidth();
        if (width === 0) return;

        const steppedPosition = slidePosition + step;
        const slideOffset = Math.ceil(clipper.offsetWidth / width);

        if (steppedPosition < 0) {
            setSlidePosition(cells.length - slideOffset);
        } else if (steppedPosition > cells.length - slideOffset) {
            setSlidePosition(0);
        } else {
            setSlidePosition(steppedPosition);
        }
    };

    useEffect(() => {
        positionCarousel();
    }, [slidePosition]);

    useEffect(() => {
        const handleResize = () => {
            // Debounce the resize handler
            if (window.resizeTimer) {
                clearTimeout(window.resizeTimer);
            }
            window.resizeTimer = setTimeout(() => {
                positionCarousel();
            }, 100);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            if (window.resizeTimer) {
                clearTimeout(window.resizeTimer);
            }
        };
    }, []);

    return (
        <div className="prints-landing-carousel-container">
            <div
                ref={clipperRef}
                className="prints-landing-carousel-clipper"
            >
                <div
                    ref={carouselRef}
                    className="prints-landing-carousel"
                >
                    {displaySlides.map(slide => slide)}
                </div>
            </div>

            <div className="button-bar">
                <button
                    className="back-button direction-button"
                    onClick={() => stepCarousel(-1)}
                    aria-label="Scroll Back"
                >
                    {IconArrowLeftSvg}
                </button>
                <button
                    className="forward-button direction-button"
                    onClick={() => stepCarousel(1)}
                    aria-label="Scroll Forward"
                >
                    {IconArrowRightSvg}
                </button>
            </div>
        </div>
    );
};

export default PrintsLandingCarousel;
